import { tagRouters, menuRouters, otherRouter, ROUTER_NAME_HOME } from "../../../router/router";
import AppPersistence from "../../../persistence/AppPersistence";
import { getMenuListByAccessCode, mapRoutersToTagList } from "./helper";
import ArrayUtils from "../../../libs/utils/ArrayUtils";


const defaultPage = otherRouter.children[0];
export const state = {
  //所有的页面tag
  tagsList: [],
  //已经打开的页面tag
  pageOpenedList: [{
    title: '首页',
    path: '',
    name: ROUTER_NAME_HOME,
    param: null,
    query: null,
  }],
  /**
   * keep-alive 缓存的页面
   */
  cachedPageList: [],
  //
  menuList: [],
  routers: [
    otherRouter,
    ...menuRouters
  ],
  heightData: null,//获取到的页面高度
  widthData: null,//获取到的页面宽度
  scrollData: {},
  enumerationList: []    //枚举列表
};

export const actions = {

  /*应用启动初始化*/
  initApp({ dispatch }) {
    dispatch("initTagList");
    dispatch("initOpenedPageList");
    // dispatch("updateMenuList");
  },
  //读取缓存的已打开页面列表
  initOpenedPageList({ state, commit }) {
    let pageList = AppPersistence.getOpenedPageList();
    let cachePageList = AppPersistence.getCachePageList();
    commit("setPageOpenedList", pageList);
    commit("setCachedPageList", cachePageList);
  },
  initTagList({ state, commit }) {
    let tagList = mapRoutersToTagList(tagRouters);
    commit("setTagList", tagList);
  },

  // //根据权限更新菜单
  // updateMenuList({state, commit}) {
  //   //读取用户登录后缓存的权限值
  //   let accessCode = UserPersistence.getAccess();
  //   let menuList = getMenuListByAccessCode(menuRouters, accessCode);
  //   commit("updateMenuList", menuList);
  // },

  /**
   * 在Main中监听路由变化，更新 pageOpenedList 和 tag信息
   */
  // onRouteChange({ state, commit }, { name, query, params }) {
  //   let pageOpenedList = state.pageOpenedList;
  //   let openedPageLen = pageOpenedList.length;
  //   let i = 0;
  //   let tagHasOpened = false;
  //   while (i < openedPageLen) {
  //     if (name === pageOpenedList[i].name) { // 页面已经打开
  //       commit("updatePageOpenedAt", { index: i, query, params });
  //       tagHasOpened = true;
  //       break;
  //     }
  //     i++;
  //   }
  //   if (!tagHasOpened) {
  //     let tag = state.tagsList.filter((item) => {
  //       if (item.children) {
  //         return name === item.children[0].name;
  //       } else {
  //         return name === item.name;
  //       }
  //     })[0];
  //     if (tag) {
  //       tag = tag.children ? tag.children[0] : tag;
  //       if (params) {
  //         tag.params = params;
  //       }
  //       if (query) {
  //         tag.query = query;
  //       }
  //       commit("addTag", tag);
  //     }
  //   }
  // },
  /**
   * 移除tag
   * @param state
   * @param commit
   * @param name
   */
  removeTag({ state, commit }, name) {
    let openedPageList = state.pageOpenedList;
    let pageLen = openedPageList.length;
    for (let i = 0; i < pageLen; i++) {
      if (openedPageList[i].name === name) {
        // clearPageState(commit, state.pageOpenedList[i]);
        commit("removeTagAt", i);
        //移除state中的tag后，更新存储
        AppPersistence.saveOpenedPageList(state.pageOpenedList);
        return;
      }
    }
  },
  // removeAllTag({state, commit}) {
  //   commit("removeAllTag");
  // },



};

export const mutations = {
  setTagList(state, tagList) {
    state.tagsList = tagList;
  },
  // addTag(state, tag) {
  //   state.tagsList.push(tag);
  // },
  setPageOpenedList(state, pageList) {
    state.pageOpenedList = pageList ? pageList : [otherRouter.children[0]];
  },
  setCachedPageList(state, cachePageList) {
    state.cachedPageList = cachePageList ? cachePageList : [];
  },
  updatePageOpenedAt(state, { index, query, params }) {
    let page = state.pageOpenedList[index];
    page.query = query;
    page.params = params;
    AppPersistence.saveOpenedPageList(state.pageOpenedList);
  },
  updateMenuList(state, menuList) {
    state.menuList = menuList;
  },
  removeTagAt(state, index) {
    state.pageOpenedList.splice(index, 1);
    state.cachedPageList.splice(index - 1, 1);
    AppPersistence.saveOpenedPageList(state.pageOpenedList);
    AppPersistence.saveCachePageList(state.cachedPageList);
  },
  removeAllTag(state) {
    state.pageOpenedList.splice(1);
    state.cachedPageList.splice(0);
    AppPersistence.saveOpenedPageList(state.pageOpenedList);
    AppPersistence.saveCachePageList(state.cachedPageList);
  },
  /**
   * 把tag移动到Home后面。
   * 目前用于在激活隐藏标签页列表中的标签页后，把激活的标签页放置到主页之后
   * @param state
   * @param tag
   */
  moveTagAfterHome: function (state, tag) {
    let pageOpenedList = state.pageOpenedList;
    let cachedPageList = state.cachedPageList;
    let index = ArrayUtils.getIndexOf(tag, pageOpenedList, (tag, item) => {
      return tag.name === item.name;
    });
    tag = pageOpenedList.splice(index, 1)[0];
    let cachePage = cachedPageList.splice(index, 1)[0];
    pageOpenedList.splice(1, 0, tag);
    cachedPageList.splice(1, 0, cachePage);
    AppPersistence.saveOpenedPageList(state.pageOpenedList);
    AppPersistence.saveCachePageList(state.cachedPageList);
  },
  addTag(state, tagObj) {
    state.pageOpenedList.push(tagObj);
    if (state.cachedPageList.indexOf(tagObj.name) === -1) {
      state.cachedPageList.push(tagObj.name);
    }
    AppPersistence.saveOpenedPageList(state.pageOpenedList);
    AppPersistence.saveCachePageList(state.cachedPageList);
  },
  removeCachedPage(state, name) {//清除页面缓存
    let cachedPageList = state.cachedPageList;
    let pageLen = cachedPageList.length;
    for (let i = 0; i < pageLen; i++) {
      if (cachedPageList[i] === name) {
        state.cachedPageList.splice(i, 1);
      }
    }
    AppPersistence.saveCachePageList(state.cachedPageList);
  },
  addCachedPage(state, name) {//增加页面缓存
    if (state.cachedPageList.indexOf(name) === -1) {
      state.cachedPageList.push(name);
    }
    AppPersistence.saveCachePageList(state.cachedPageList);
  },


  openNewPage(state, { name, query, params }) {
    let pageOpenedList = state.pageOpenedList;
    let openedPageLen = pageOpenedList.length;
    let i = 0;
    let tagHasOpened = false;
    while (i < openedPageLen) {
      if (name === pageOpenedList[i].name) { // 页面已经打开
        // vm.$store.commit('pageOpenedList', {
        //   index: i,
        //   argu: argu,
        //   query: query
        // });
        // updatePageOpenedList(state,{index:i,query:query,params:params});
        state.pageOpenedList[i] = {
          name,
          query,
          params
        };

        tagHasOpened = true;
        break;
      }
      i++;
    }
    if (!tagHasOpened) {
      let tag = state.tagsList.filter((item) => {
        if (item.children) {
          return name === item.children[0].name;
        } else {
          return name === item.name;
        }
      })[0];
      if (tag) {
        tag = tag.children ? tag.children[0] : tag;
        if (params) {
          tag.params = params;
        }
        if (query) {
          tag.query = query;
        }
      }
    }
  },
  /**
   * 移除最后N个标签
   */
  removeLastTags(state, n) {
    let delFromIndex = state.pageOpenedList.length - n;
    state.pageOpenedList.splice(delFromIndex, n);
    state.cachedPageList.splice(delFromIndex - 1, n);
    AppPersistence.saveOpenedPageList(state.pageOpenedList);
    AppPersistence.saveCachePageList(state.cachedPageList);
  },
  /**
   * 移除其他标签
   */
  removeOtherTags(state, noCloseList) {
    let pageOpenedList = state.pageOpenedList.filter((item) => {
      return ArrayUtils.getItemIndex(noCloseList, 'name', item.name) > -1;
    })
    let cachedPageList = state.cachedPageList.filter((item) => {
      return ArrayUtils.getItemIndex(noCloseList, 'name', item) > -1;
    })
    state.pageOpenedList = pageOpenedList;
    state.cachedPageList = cachedPageList;
    AppPersistence.saveOpenedPageList(pageOpenedList);
    AppPersistence.saveCachePageList(cachedPageList);
  },
  removeTags(state, pageList) {
    let len = state.pageOpenedList.length;
    let remainPage = [];
    for (let i = 0; i < pageList.length; i++) {
      let page = pageList[i];
      for (let j = 0; j < len; j++) {
        if (state.pageOpenedList[j].name === page) {
          remainPage.push(state.pageOpenedList[j]);
          break;
        }
      }
    }
    state.pageOpenedList = remainPage;
    state.cachedPageList = [pageList[1]];
    AppPersistence.saveOpenedPageList(state.pageOpenedList);
    AppPersistence.saveCachePageList(state.cachedPageList);
  },


  setHeightData(state, heightData) {
    state.heightData = heightData
  },
  setWidthData(state, widthData) {
    state.widthData = widthData
  },
  //设置页面表格滚动条的高度
  setScrollTop(state, { routeName, top, left }) {
    state.scrollData[routeName] = {
      scrollTop: top,
      scrollLeft: left,
    }
  },


};

export const getters = {};
export const moduleId = "app";



// WEBPACK FOOTER //
// ./src/store/modules/app/index.js